import React, { memo } from "react";

function EmptyScreen({ heading, subHeading }) {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center flex-column py-5">
      <img src="/No Connection illustartion.svg" alt="no content" />
      <h5>{heading}</h5>
      <label className="my-3">{subHeading}</label>
    </div>
  );
}

export default memo(EmptyScreen);
